import { useEffect, useState } from "react";
import { MessageCircle, ArrowUp, ClipboardList } from "lucide-react";
import { waLink } from "../../lib/api";
import QuoteWizard from "../QuoteWizard";

export const openQuoteWizard = (payload = {}) =>
  window.dispatchEvent(new CustomEvent("quotewizard:open", { detail: payload }));

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardProps, setWizardProps] = useState({});

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      setWizardProps(e.detail || {});
      setWizardOpen(true);
    };
    window.addEventListener("quotewizard:open", handler);
    return () => window.removeEventListener("quotewizard:open", handler);
  }, []);

  return (
    <>
      <div className="fixed bottom-24 right-5 z-[60] flex flex-col gap-3" data-testid="floating-actions">
        {showTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="h-11 w-11 rounded-full bg-navy text-white flex items-center justify-center shadow-lg hover:bg-[#123b52] transition-colors"
            aria-label="Yukarı"
            data-testid="back-to-top"
          >
            <ArrowUp size={18} />
          </button>
        )}
        <a
          href={waLink("Merhaba, otel ekipmanları hakkında bilgi almak istiyorum.")}
          target="_blank"
          rel="noreferrer"
          className="h-12 w-12 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
          aria-label="WhatsApp"
          data-testid="whatsapp-float"
        >
          <MessageCircle size={20} />
        </a>
        <button
          onClick={() => setWizardOpen(true)}
          className="group relative h-14 w-14 rounded-full bg-gold text-white flex items-center justify-center shadow-[0_10px_30px_rgba(214,176,107,0.45)] hover:bg-[#c49d58] animate-gold-pulse transition-all"
          aria-label="Teklif Sihirbazı"
          data-testid="quote-wizard-fab"
        >
          <ClipboardList size={22} />
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-navy text-white text-xs px-3 py-1.5 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Teklif Sihirbazı
          </span>
        </button>
      </div>
      <QuoteWizard open={wizardOpen} onClose={() => { setWizardOpen(false); setWizardProps({}); }} {...wizardProps} />
    </>
  );
}
